import { useEffect } from "react";

import { AgentsClient } from "@citrine/resources/agents";
import { useConfiguration } from "@citrine/resources/configuration";

import { useCatalystContext } from "#src/contexts/catalyst";

/**
 * Headless component that pushes agent availability — LD flag on AND at least
 * one agent discovered — into the Catalyst context. Kept out of the provider
 * so context consumers (e.g. tests) don't all have to run the agents query.
 */
export function SetCatalystAgentAvailability() {
  const { setAgentEnabled } = useCatalystContext();
  const enableCatalystAgent = useConfiguration("enableCatalystAgent");

  const { data: agents } = AgentsClient.getInstance().useList({
    enabled: enableCatalystAgent,
  });

  const hasAgents = Boolean(agents?.length);

  useEffect(() => {
    setAgentEnabled(enableCatalystAgent && hasAgents);
  }, [enableCatalystAgent, hasAgents, setAgentEnabled]);

  return null;
}
